<template>
    <svg :width="width" :height="height" :viewBox="`0 0 ${width} ${height}`" fill="none" xmlns="http://www.w3.org/2000/svg" :class="classes">
        <path d="M15.75 24.15C11.725 24.15 3.5 26.25 3.5 30.275V33.25H28V30.1C28 26.075 19.775 24.15 15.75 24.15ZM7.525 29.75C8.925 28.7 12.6 27.65 15.75 27.65C18.9 27.65 22.4 28.875 23.975 29.75H7.525ZM15.75 21C19.075 21 21.875 18.2 21.875 14.875C21.875 11.55 19.075 8.75 15.75 8.75C12.425 8.75 9.625 11.55 9.625 14.875C9.625 18.2 12.425 21 15.75 21ZM15.75 12.25C17.15 12.25 18.375 13.475 18.375 14.875C18.375 16.275 17.15 17.5 15.75 17.5C14.35 17.5 13.125 16.275 13.125 14.875C13.125 13.475 14.35 12.25 15.75 12.25Z" fill="#071689"/>
        <path d="M28.3503 24.1501C30.4503 25.5501 31.8503 27.6501 31.8503 30.1001V33.2501H38.8503V30.1001C38.8503 26.6001 32.7253 24.6751 28.3503 24.1501Z" fill="#32DAC3"/>
        <path d="M26.6003 21C29.9253 21 32.7253 18.2 32.7253 14.875C32.7253 11.55 29.9253 8.75 26.6003 8.75C25.7253 8.75 24.8503 8.925 23.9753 9.275C25.0253 10.85 25.7253 12.775 25.7253 14.875C25.7253 16.975 25.0253 18.9 23.9753 20.3C24.6753 20.825 25.5503 21 26.6003 21Z" fill="#32DAC3"/>
    </svg>
</template>

<script>
export default {
    name: "ConsumerIcon",

    props: {
        width: {
            type: Number,
            default: 42
        },

        height: {
            type: Number,
            default: 42
        },

        classes: {
            type: String
        }
    }
}
</script>